import { render, staticRenderFns } from "./CalendarTask.vue?vue&type=template&id=fa0b9424&"
import script from "./CalendarTask.vue?vue&type=script&lang=js&"
export * from "./CalendarTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports